import React from 'react';
import { Box, CircularProgress, Grid } from '@material-ui/core';
import { AccordionSummary } from '@material-ui/core';
import { injectIntl, IntlShape } from 'react-intl';
import { get } from 'lodash';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import StatusChip from 'components/StatusChip';
import { StyledCaption, StyledShortBody } from 'components/Refunds/styles';
import { ShortBody } from 'components/Typography';
import { StyledAccordionDetails } from 'containers/AmcDetailsPage/MyRefundsTab/Refunds/styles';
import messages from 'components/Refunds/messages';
import { translate } from 'helpers/intl';

interface PecClaimType {
  intl: IntlShape;
  refund: {
    statusApplication: String;
    maladyDeclarationSuffix: String;
    numeroPolicy: String;
    numeroApplication: Number;
    beneficiary: String;
    dateNum: Number;
    years: Number;
    dateOccu: string;
    montantPriseEnCharge?: string;
  };
  refundDetails: {
    numDossier: String;
    dateSurvenance: String;
    numSinistre: String;
    fraisEngagement: String;
    statusNum: Number;
    status: String;
    rib: String;
    montantRegle: String;
    modeReglement: String;
    dateEvenement: String;
    montantPriseEnCharge?: string;
  };
  isLoading: boolean;
  expanded: boolean | String;
  index: string;
}

const PecClaim = ({
  refund,
  refundDetails,
  expanded,
  index,
  isLoading,
  ...props
}: PecClaimType) => {
  return (
    <>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Box width="100%">
          <Grid container justify="space-between">
            <Grid item xs={12} sm={3}>
              <Grid item>
                <StyledCaption>
                  {translate(get(messages, 'folderNumber'), props)}
                </StyledCaption>
              </Grid>
              <Grid item>
                <Box marginBottom={0}>
                  <StyledShortBody>
                    {refund.numeroApplication +
                      '' +
                      refund.maladyDeclarationSuffix}
                  </StyledShortBody>
                </Box>
              </Grid>
            </Grid>
            <Grid item xs={6} sm>
              <Grid container direction="column">
                <Grid item>
                  <StyledCaption>
                    {translate(get(messages, 'Beneficiary'), props)}
                  </StyledCaption>
                </Grid>
                <Grid item>
                  <ShortBody>{refund.beneficiary}</ShortBody>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6} sm>
              <Grid container direction="column">
                <Grid item>
                  <StyledCaption>
                    {translate(get(messages, 'status'), props)}
                  </StyledCaption>
                </Grid>
                <Grid item>
                  <Box marginBottom={0}>
                    <StatusChip
                      status={'warning'}
                      label={translate(get(messages, 'statusPec'), props)}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </AccordionSummary>
      {expanded &&
        index === expanded &&
        (isLoading ? (
          <Grid
            container
            justify="center"
            style={{ marginTop: 40, marginBottom: 40 }}
          >
            <CircularProgress color="inherit" size={20} />
          </Grid>
        ) : (
          <StyledAccordionDetails>
            <Box width="100%">
              <Grid container justify="space-between">
                <Grid item xs={6} sm>
                  <Grid container direction="column">
                    <Grid item>
                      <StyledCaption>
                        {translate(get(messages, 'lossDate'), props)}
                      </StyledCaption>
                    </Grid>
                    <Grid item>
                      <ShortBody>{refund.dateOccu}</ShortBody>
                    </Grid>
                  </Grid>
                </Grid>
                {/* <Grid item xs={6} sm>
                  <Grid container direction="column">
                    <Grid item>
                      <StyledCaption>
                        {translate(get(messages, 'claimNumber'), props)}
                      </StyledCaption>
                    </Grid>
                    <Grid item>
                      <Grid item>
                        <ShortBody>{refundDetails.numSinistre}</ShortBody>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid> */}
                <Grid item xs={6} sm>
                  <Grid container direction="column">
                    <Grid item>
                      <StyledCaption>
                        {translate(get(messages, 'costs'), props)}
                      </StyledCaption>
                    </Grid>
                    <Grid item>
                      <ShortBody>
                        {refundDetails.fraisEngagement + ' DH'}
                      </ShortBody>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={6} sm>
                  <Grid container direction="column">
                    <Grid item>
                      <StyledCaption>
                        {translate(get(messages, 'grantedFees'), props)}
                      </StyledCaption>
                    </Grid>
                    <Grid item>
                      <ShortBody style={{ fontWeight: 'bold' }}>
                        {refundDetails?.montantPriseEnCharge + ' DH'}
                      </ShortBody>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={6} sm></Grid>
              </Grid>
            </Box>
          </StyledAccordionDetails>
        ))}
    </>
  );
};

export default injectIntl(PecClaim);
